export const iconFontAwesomeMedicalHealthHouseChimneyMedical = (
	<i className="fa-solid fa-house-chimney-medical"></i>
);
